const group = {
  '> a + a, > button + button': {
    ml: 3,
    mt: [3, null, 0]
  }
}

export default group